(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morris-story-layout"]) return;
  try {
    
function initMorrisStorySticky(){
 const button=document.querySelector('[data-morris-story-sticky]');
 if(!button||button.dataset.ready)return;
 button.dataset.ready='true';
 const end=document.querySelector('[id*="__final_"]');
 if(end)new IntersectionObserver(entries=>{button.hidden=entries[0].isIntersecting;},{threshold:0.1}).observe(end);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initMorrisStorySticky);else initMorrisStorySticky();
document.addEventListener('shopify:section:load',initMorrisStorySticky);

  } catch(e) { console.error(e); }
})();
})();
